<script setup lang="ts">
import useDialogStore from '@/stores/dialog';

// Instances
const dialogStore = useDialogStore();

// Data
const {options, component} = storeToRefs(dialogStore);

// Methods
const close = (): void => {
    dialogStore.close();
};
</script>

<template>
    <Component
        v-if="component"
        :is="component"
        v-bind="options"
        @close="close"
    />
</template>

<style scoped>

</style>
